type TServiceBreadcrumbState = {
    from?: string
} | null

export type TBreadcrumbItem = {
    label: string
    path?: string
    active?: boolean
}

export const buildBreadcrumbPaths = (pathname: string): string[] => {
    const paths = ['/']

    if (pathname === '/') {
        return paths
    }

    pathname.split('/').reduce((previousPath, currentPart) => {
        const nextPath = `${previousPath}/${currentPart}`
        paths.push(nextPath)
        return nextPath
    })

    return paths
}

export const buildServiceBreadcrumbs = (
    pathname: string,
    _state: TServiceBreadcrumbState
): TBreadcrumbItem[] | null => {
    if (
        pathname === '/services/dns' ||
        /^\/services\/dns\/[^/]+$/.test(pathname) ||
        /^\/services\/[^/]+$/.test(pathname)
    ) {
        return [
            { label: 'Home', path: '/' },
            { label: 'Services', active: true },
        ]
    }

    return null
}
